<template>
    <el-dialog title="图片预览" :visible.sync="imgShow" width="50%" append-to-body center v-if="imgShow" @close="$emit('closeModel')">
        <img :src="imgSrc" alt="" class="view_img">
        <div slot="footer" class="dialog-footer">
            <el-button @click="$emit('closeModel')">关闭</el-button>
        </div>  
    </el-dialog>
</template>
<script>
export default {
    props:{
        imgShow:{
            require: true,
            default:false
        },
        imgSrc:{
            require:true,
            default:""
        }
    }
}
</script>

<style lang="scss" scoped>
    .view_img{
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
    }

</style>